// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app\\components\\pages\\locations\\WelcomeSection\\index.ts"
);
import.meta.hot.lastModified = "1757171103328.2522";
}
// REMIX HMR END

export { WelcomeSection } from "./WelcomeSection";